export { CarouselProducts } from './CarouselProducts';
export { default } from './DefaultCarouselProducts';
export type { IPrismicCarouselProductsPrimary } from './types';
export { getPageContentsWithProducts } from './getPageContentsWithProducts';
